import React from 'react';

import { EmptyState } from '@ergeon/core-components';
import { ChatBubbleLeftIcon } from '@ergeon/icons/hero/outline';

export const NoConversationsEmptyState = () => (
  <div className="flex flex-col flex-grow justify-center items-center p-6 pb-12">
    <EmptyState
      description="Start your first conversation by clicking the 'New' button above."
      icon={<ChatBubbleLeftIcon />}
      title="No conversations yet" />
  </div>
);
